import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1044.768,224 L1195.59467,374.826667 L888.714667,681.706667 L988.128,681.706667 C1496.928,681.706667 1910.79467,1095.57333 1910.79467,1604.37333 L1910.79467,1604.37333 L1910.79467,1695.04 L1697.46133,1695.04 L1697.46133,1604.37333 C1697.46133,1213.22667 1379.27467,895.04 988.128,895.04 L988.128,895.04 L887.968,895.04 L1195.59467,1202.77333 L1044.768,1353.6 L479.968,788.8 L1044.768,224 Z M564.8,224 L715.626667,374.826667 L301.653333,788.8 L715.626667,1202.77333 L564.8,1353.6 L0,788.8 L564.8,224 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconReplyAll2Solid = /*#__PURE__*/function (_Component) {
  _inherits(IconReplyAll2Solid, _Component);

  var _super = _createSuper(IconReplyAll2Solid);

  function IconReplyAll2Solid() {
    _classCallCheck(this, IconReplyAll2Solid);

    return _super.apply(this, arguments);
  }

  _createClass(IconReplyAll2Solid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReplyAll2",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconReplyAll2Solid.displayName = "IconReplyAll2Solid";
  return IconReplyAll2Solid;
}(Component);

IconReplyAll2Solid.glyphName = 'reply-all-2';
IconReplyAll2Solid.variant = 'Solid';
IconReplyAll2Solid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconReplyAll2Solid;
export { IconReplyAll2Solid };